import { getAdminRevenus_ExpensesApi } from "../../helpers/backend_helper";
import {
    setRevenueAndExpenses,
    loadingRevenueAndExpenses,
    revenueAndExpensesError,
} from "./reducer";

export const fetchRevenueAndExpenses = () => async (dispatch) => {
    try {
        dispatch(loadingRevenueAndExpenses(true));

        const response = await getAdminRevenus_ExpensesApi();
        dispatch(setRevenueAndExpenses(response));
    } catch (error) {
        const message = error?.response?.data?.detail || "Failed to load revenue and expenses.";
        dispatch(revenueAndExpensesError(message));
    } finally {
        dispatch(loadingRevenueAndExpenses(false));
    }
};
